__turbopack_context__.v({
  "container": "AvisoProgramaDeReferidos-module__fEKV4G__container",
  "container__forma": "AvisoProgramaDeReferidos-module__fEKV4G__container__forma",
  "container__wrapper": "AvisoProgramaDeReferidos-module__fEKV4G__container__wrapper",
  "container__wrapper__description_container": "AvisoProgramaDeReferidos-module__fEKV4G__container__wrapper__description_container",
  "container__wrapper__item": "AvisoProgramaDeReferidos-module__fEKV4G__container__wrapper__item",
  "container__wrapper__item__table_container": "AvisoProgramaDeReferidos-module__fEKV4G__container__wrapper__item__table_container",
  "container__wrapper__pre": "AvisoProgramaDeReferidos-module__fEKV4G__container__wrapper__pre",
  "container__wrapper__title": "AvisoProgramaDeReferidos-module__fEKV4G__container__wrapper__title",
});
